import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

export default function VendorList() {
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [open, setOpen] = useState(false);

  const vendors = [
    {
      id: 1,
      name: "ABC Vendor",
      email: "abc@gmail.com",
      phone: "9876543210",
      poIssued: [
        {
          poNo: "PO-101",
          amount: "₹15,000",
          status: "Issued",
          date: "18 May 2026",
        },
        {
          poNo: "PO-102",
          amount: "₹22,000",
          status: "Pending",
          date: "19 May 2026",
        },
      ],
    },
    {
      id: 2,
      name: "XYZ Vendor",
      email: "xyz@gmail.com",
      phone: "9999999999",
      poIssued: [
        {
          poNo: "PO-201",
          amount: "₹40,000",
          status: "Issued",
          date: "20 May 2026",
        },
      ],
    },
  ];

  const handleOpen = (vendor) => {
    setSelectedVendor(vendor);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedVendor(null);
  };

  return (
    <div className="p-6">
      {/* Heading */}
      <h2 className="text-2xl font-bold mb-6">Vendor List</h2>

      {/* Vendor Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {vendors.map((vendor) => (
          <div
            key={vendor.id}
            onClick={() => handleOpen(vendor)}
            className="
              cursor-pointer
              bg-white
              border
              rounded-2xl
              p-5
              shadow-sm
              hover:shadow-xl
              transition-all
              duration-300
            "
          >
            <h3 className="text-xl font-semibold mb-2">{vendor.name}</h3>

            <p className="text-gray-500 text-sm mb-1">{vendor.email}</p>

            <p className="text-gray-500 text-sm">{vendor.phone}</p>

            <div className="mt-4">
              <span
                className="
                  bg-blue-100
                  text-blue-700
                  px-3
                  py-1
                  rounded-full
                  text-xs
                  font-medium
                "
              >
                {vendor.poIssued.length} PO Issued
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {selectedVendor?.name}

          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 10,
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <p className="text-gray-500 mb-1">{selectedVendor?.email}</p>

          <p className="text-gray-500 mb-5">{selectedVendor?.phone}</p>

          <h3 className="text-lg font-bold mb-4">PO Issued</h3>

          <div className="space-y-3">
            {selectedVendor?.poIssued?.map((po, index) => (
              <div
                key={index}
                className="
                  border
                  rounded-lg
                  p-4
                  flex
                  justify-between
                  items-center
                "
              >
                <div>
                  <p className="font-semibold">{po.poNo}</p>

                  <p className="text-sm text-gray-500">{po.date}</p>
                </div>

                <div className="text-right">
                  <p>{po.amount}</p>

                  <span
                    className={`
                      px-2 py-1 rounded text-xs text-white
                      ${
                        po.status === "Issued"
                          ? "bg-green-500"
                          : "bg-yellow-500"
                      }
                    `}
                  >
                    {po.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
